import type { AuthUserLoginRequest } from '../services/auth.service';
import { authService } from '../services/auth.service';

export function hasAllOAuthParams(params: URLSearchParams): boolean {
  return ['code', 'scope', 'authuser', 'hd', 'prompt'].every(
    (key) => !!params.get(key)
  );
}

export function extractOAuthParams(searchParams: URLSearchParams): AuthUserLoginRequest {
  return {
    code: searchParams.get('code') || '',
    scope: searchParams.get('scope') || '',
    authuser: searchParams.get('authuser') || '',
    hd: searchParams.get('hd') || '',
    prompt: searchParams.get('prompt') || '',
    return_url: searchParams.get('return_url') || authService.getReturnUrl(),
  };
}
